<template>
  <textarea
    class="form-control"
    rows="6"
    :value="value"
    @input="$emit('input', $event.target.value)"
    @blur="saveDialogNote"
  ></textarea>
</template>

<script>
export default {
  props: {
    dialogId: {
      required: true,
      type: Number
    },
    fake: {
      required: true,
      type: Boolean
    },
    value: {
      required: true,
      type: String
    }
  },
  methods: {
    saveDialogNote() {
      this.savingDialogNotes = true;

      let data = {};

      if (this.fake) {
        data.fake_notes = this.value;
      } else {
        data.customer_notes = this.value;
      }

      this.$http
        .patch("/api/v1/dialog/notes/" + this.dialogId, data)
        .then(() => {
          this.$notify({
            title: "Die Dialoginformationen wurden gespeichert",
            type: "success"
          });
        })
        .finally(() => {
          this.savingDialogNotes = false;
        });
    }
  }
};
</script>
